import { render, staticRenderFns } from "./BulkCorpInsurance.vue?vue&type=template&id=33aa60c7&scoped=true&"
import script from "./BulkCorpInsurance.vue?vue&type=script&lang=js&"
export * from "./BulkCorpInsurance.vue?vue&type=script&lang=js&"
import style0 from "./BulkCorpInsurance.vue?vue&type=style&index=0&id=33aa60c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa60c7",
  null
  
)

export default component.exports